import { createContext } from 'react';

import { Form } from '@interfaces/forms';

const FormData = createContext<Partial<Form>>(undefined!);

export default FormData;
